import { restLog } from "src/utils/functions/logging"
import { content, isJson, msg, _logout, isLocal, noti } from "src/utils/functions/core"
import { checkNode } from "./queryCheck"
// console.log(layout)
const _headers = (data, method) => {
  const { user, layout, token, licence } = content()
  const devMode = licence?.devMode
  const browserId = isLocal("browserId")
  return {
    'Content-Type': 'application/json',
    'token': data.token,
    'userId': user?._id,
    'devMode': licence?.devMode,
    'browserId': browserId,
    'pathname': window.location.pathname,
    'method': method
  }
}

const API_PREFIX = "/api/";

const normalizeUrl = (url) => {
  if (!url) return url;
  return url.startsWith("/api/") ? url : API_PREFIX + url;
};


const querySelectValidation = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl + "?body=" + JSON.stringify(data), {
    method: 'GET',
    headers: _headers(data, 'GET'),
  })
    .then(res => res.json())
    .catch(err => err);
};

const querySelectCustom = async (data) => {
  const _checkNode = await checkNode();
  if (!_checkNode) {
    noti("error", "Database error", "Database connection lost");
    return;
  }

  const { user, layout, systemAdminGroups } = content();
  data.systemAdmin = systemAdminGroups ? true : false;

  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl + "?body=" + JSON.stringify(data), {
    method: 'GET',
    headers: _headers(data, 'GET'),
  })
    .then(res => res.json())
    .catch(err => err);
};

const querySelectPut = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl, {
    method: 'PUT',
    headers: _headers(data, 'PUT'),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .catch(err => err);
};

const querySelectPost = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl, {
    method: 'POST',
    headers: _headers(data, 'POST'),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .catch(err => err);
};

const querySelectDelete = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl, {
    method: 'DELETE',
    headers: _headers(data, 'DELETE'),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .catch(err => err);
};

const queryFilter = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl + "?body=" + JSON.stringify(data), {
    method: 'GET',
    headers: _headers(data, 'GET'),
  })
    .then(res => res.json())
    .catch(err => err);
};

const querySelect = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl + "?body=" + JSON.stringify(data), {
    method: 'GET',
    headers: _headers(data, 'GET'),
  })
    .then(res => res.json())
    .then(el => el.success ? el.data : false)
    .catch(err => err);
};

const queryPut = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl, {
    method: 'PUT',
    headers: _headers(data, 'PUT'),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(el => el.success ? el.data : false)
    .catch(err => err);
};

const queryPost = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl, {
    method: 'POST',
    headers: _headers(data, 'POST'),
    body: JSON.stringify(data)
  })
    .then(res => res.json())
    .then(el => el.success ? el.data : false)
    .catch(err => err);
};

const queryDownload = (data) => {
  const finalUrl = normalizeUrl(data.url);

  return fetch(finalUrl + "?body=" + JSON.stringify(data), {
    method: 'GET',
    headers: _headers(data, 'GET'),
  })
    .then(res => res.blob())
    .catch(err => err);
};

const configData = (data) => {
  return querySelectCustom({
    url: "/api/web_data",   // explicit override
  })
    .then((res) => {
      if (res?.success) return res;
      noti("error", "Check web config", "Config missing or cb error", 2);
    });
};


export { querySelectCustom, querySelectPut, querySelectPost, querySelect, queryPut, queryPost, queryDownload, queryFilter, querySelectValidation, querySelectDelete, configData }
